import React, { Suspense } from "react";
import { BrowserRouter } from "react-router";
import AppRoutes from "./routes/AppRoutes";
import { ThemeProvider } from "@mui/material";
import theme from "./style/theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "./style/App.css";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 دقیقه
        gcTime: 10 * 60 * 1000, // 10 دقیقه
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
      },
    },
  });

  return (
    <div className="App">
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
              <Suspense fallback={<div>در حال بارگذاری...</div>}></Suspense>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
              />
              <AppRoutes />
              <div className="fixed bottom-0 right-0 left-0 flex justify-center items-center p-2 backdrop-blur-md bg-white/10 border-y border-white/20 shadow-xl">
                <img
                  className=" w-[150px] h-[30px]"
                  src={'/20_card.svg'}
                  alt="card"
                />
              </div>
            </ThemeProvider>
          </QueryClientProvider>
        </LocalizationProvider>
      </BrowserRouter>
    </div>
  );
}
export default App;
